import React from 'react';
import { ComponentParams, Field } from '@sitecore-content-sdk/nextjs';

import { SearchDropDown } from './SearchDropDown';
import { Themes } from 'lib/themes';
import { ComponentProps } from 'lib/component-props';

type SearchDropDownSitecoreProps = ComponentProps & {
  fields?: {
    presearchText?: Field<string> | string;
  };
  params?: ComponentParams & {
    theme?: Themes;
    query?: string;
  };
};

const parseMultilineText = (text: string) => {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
};

export const Default = (props: SearchDropDownSitecoreProps) => {
  const rawTextField = props.fields?.presearchText;
  const rawText = typeof rawTextField === 'string' ? rawTextField : rawTextField?.value || '';

  return (
    <SearchDropDown
      items={parseMultilineText(rawText)}
      query={props.params?.query}
      theme={props.params?.theme as Themes}
      onSelect={() => undefined}
    />
  );
};
